// src/components/EnrichSingleRoomButton.tsx
import React from "react";
import { Button, Loader, Flex, Text, Alert } from "@mantine/core";
import { usePostMultiplacerEnrichRoomMutation } from "../../openapi";
import { useAppSelector } from "../app/hooks";

export const EnrichSingleRoomButton: React.FC = () => {
  const [trigger, { isLoading, isError, isSuccess, data, error, reset }] =
    usePostMultiplacerEnrichRoomMutation();

  const projectNo = useAppSelector((state) => state.design.projectNo);
  const roomNumber = useAppSelector((state) => state.design.selectedSpaceNumber);

  const handleClick = async () => {
    if (projectNo == null || roomNumber == null) {
      return;
    }
    reset(); // nollställer tidigare error/success
    await trigger({
      body: {
        projectNo,
        roomNr: roomNumber,
        jobTypes: ["standardRoom.E", "standardRoom.V", "addIfcInfo", "mlPredictDevices"],
        dryRun: false,
      },
    });
  };

  return (
    <div>
      <Button loading={isLoading} disabled={isLoading} onClick={handleClick} style={{ width: 200 }}>
        Kjør berikning
      </Button>

      {/* Loading feedback under knappen */}
      {isLoading && (
        <Flex align="center" gap={6} mt={4}>
          <Loader size="xs" />
          <Text size="xs" c="dimmed">
            Kjører berikning…
          </Text>
        </Flex>
      )}

      {/* Success */}
      {isSuccess && !isLoading && (
        <Alert color="green" title="Suksess" mt="xs" withCloseButton onClose={reset}>
          Rommet er beriket med oppdatert valideringsdata.
        </Alert>
      )}

      {/* Error */}
      {isError && !isLoading && (
        <Alert color="red" title="Feil" mt="xs" withCloseButton onClose={reset}>
          {(error as any)?.data?.error || "Kunne ikke kjøre berikning."}
        </Alert>
      )}
    </div>
  );
};
